// @ts-nocheck
declare module '*.vue' {
    import Vue from 'vue';
    export default Vue;
}
